import React from 'react';
import { Link } from '@inertiajs/react';
import { Button } from "@/Components/ui/button";

interface FieldInfoHeaderProps {
    fieldName: string;
    distance: number;
    onBookNow: () => void;
}

const FieldHeader: React.FC<FieldInfoHeaderProps> = ({ fieldName, distance, onBookNow }) => {
    return (
        <div className="bg-bluegray w-full py-8 px-6 flex flex-col md:flex-row items-start md:items-center justify-between shadow-md">
            <h1 className="text-3xl font-bold text-gray-900 mb-4 md:mb-0">{fieldName}</h1>
            <div className="flex flex-row items-center space-x-4 w-full md:w-auto justify-between md:justify-end">
                <span className="text-lg text-black whitespace-nowrap">
                    Starting at {fieldName === 'Amwell' ? '£10.00' : '£8.00'}
                </span>
                <a href="#booking">
                    <Button
                        className="bg-brand hover:bg-brand/90 text-white whitespace-nowrap"
                        onClick={onBookNow}
                    >
                        Book Now
                    </Button>
                </a>
            </div>
        </div>
    );
};

export default FieldHeader;
